module.exports = __webpack_public_path__ + "img/gridnodata.5e05f2dd.png";